
























































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component({
    components: {}
})
export default class DialogComponent extends Vue {
    /**
        * properties
    */
    @Prop({ default: false }) dialog!:  boolean
    @Prop({ default: 450 }) width!: number
    @Prop() height!: number
    @Prop({ default: '' }) title!: string
    @Prop({ default: [] }) actions!: Array<any>
    @Prop() cssclass: string;
    @Prop({ default: false }) loader: boolean;

    selectedAction: string = "";
}
